import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const DiscountSummary = ApplicationRecord.extend({
  attrs: {
    banner_subtext: attr(),
    banner_title: attr(),
    criteria: attr(),
    customer_id: attr(),
    delivery_date: attr(),
    discount_amount: attr(),
    expires_at: attr(),
    offer: attr(),
    promotion_id: attr(),
    purchasable_id: attr(),
    purchasable_type: attr(),
    purchase_value: attr(),
    redemption_id: attr(),
    state: attr(),
  },
  static: {
    jsonapiType: 'vouchers-discount_summaries',
  },
});

export default DiscountSummary;
